module.exports = __webpack_public_path__ + "img/member-card.90096af3.svg";